/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/10/19
 * Time: 9:27 AM
 */
import React from 'react'
import {Input} from 'semantic-ui-react'
import '../LabelButtonsInput/LabelButtonsInput.css'
import {Form} from "semantic-ui-react";

const App = (props) => (
  <Form.Field
    className={`${props.className} ${props.required?`required-comp`:``}`}
    required={props.required}
    id={props.id}
    control={Input}
    label={props.tagText}
    placeholder={props.placeholder}
    onChange={props.onChange}
    value={props.value}
    disabled={props.disable}
    type={props.type}
    name={props.name}
  />
);

export default App
